module.exports = __webpack_public_path__ + "img/empty-pickup.88310c57.svg";